export default "__VITE_ASSET__DBXtD9kh__"